export default __webpack_public_path__ + "static/media/naci1.47d470b1.png";